import React, {Component} from 'react';

import '../../styles/elements/textBlock.css';

class TextBlock extends Component {
    render() {
        return (
            <div className={'text-block' + (this.props.className ? ' ' + this.props.className : '')}>
                <div className="container text-block__container">
                    {this.props.title ? (<h2 className="text-block__title">{ this.props.title }</h2>) : ''}
                    <div className="text-block__content">
                        {this.props.content}
                    </div>
                </div>
            </div>
        )
    }


}

export default TextBlock;



// WEBPACK FOOTER //
// ./src/js/elements/TextBlock.js